"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Pagination = void 0;
var react_1 = __importDefault(require("react"));
var Container_1 = require("../Container/Container");
var PaginationContext_1 = require("./PaginationContext");
var Pagination = function (props) {
    var className = props.className, _a = props.page, page = _a === void 0 ? 1 : _a, onChange = props.onChange, children = props.children, _b = props.pageMin, pageMin = _b === void 0 ? 1 : _b, _c = props.pageMax, pageMax = _c === void 0 ? 10 : _c, _d = props.pageLimit, pageLimit = _d === void 0 ? Infinity : _d, rest = __rest(props, ["className", "page", "onChange", "children", "pageMin", "pageMax", "pageLimit"]);
    var providerValue = PaginationContext_1.useInitializeContext({
        page: page,
        pageMin: pageMin,
        pageMax: pageMax,
        pageLimit: pageLimit,
        onChange: onChange
    });
    return (react_1["default"].createElement(PaginationContext_1.PaginationContext.Provider, { value: providerValue },
        react_1["default"].createElement(Container_1.Container, __assign({ className: ['pagination', className] }, rest), children)));
};
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map